import React from 'react';
import { useParams, Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import SitePartner from '../components/SitePartner';
import { safetyArticles } from '../data/articles';

const ArticlePage = () => {
  const { id } = useParams();
  const article = safetyArticles[id];

  if (!article) {
    return (
      <div className="min-h-screen flex flex-col items-center justify-center p-4">
        <h1 className="text-2xl font-bold">Article Not Found</h1>
        <Link to="/driving" className="mt-4 text-blue-600 font-bold">Return to Driving Page</Link>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-slate-50 py-12 px-4 sm:px-6">
      <div className="max-w-4xl mx-auto">
        <SitePartner className="mb-8" />
        
        <Link 
          to="/driving" 
          className="inline-flex items-center gap-2 text-slate-500 hover:text-slate-900 font-black mb-8 transition-colors uppercase tracking-wider"
        >
          <SafeIcon name="ArrowLeft" /> BACK TO DRIVING GUIDES
        </Link>

        <motion.div 
          initial={{ opacity: 0, y: 20 }} 
          animate={{ opacity: 1, y: 0 }}
          className="bg-white rounded-3xl shadow-2xl border border-slate-100 overflow-hidden"
        >
          <div className="p-8 md:p-12 border-b border-slate-100 bg-slate-900 text-white text-center">
            <h1 className="text-4xl md:text-5xl font-black mb-4 leading-tight uppercase tracking-tighter">
              {article.title}
            </h1>
            <p className="text-xl text-blue-400 font-bold uppercase tracking-widest">
              {article.subtitle}
            </p>
          </div>

          <div className="p-4 md:p-8 bg-slate-100">
            <div className="aspect-video w-full rounded-2xl overflow-hidden bg-black shadow-2xl ring-1 ring-white/10">
              <iframe 
                className="w-full h-full"
                src={article.videoUrl} 
                title={article.title} 
                frameBorder="0" 
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" 
                allowFullScreen
              ></iframe>
            </div>
          </div>

          <div className="p-8 bg-blue-50 border-t border-blue-100">
            <div className="flex items-start gap-4 max-w-2xl mx-auto">
              <SafeIcon name="Info" className="text-blue-600 text-2xl mt-1 shrink-0" />
              <div>
                <p className="font-black text-blue-900 uppercase tracking-wide">Video Only Mode</p>
                <p className="text-blue-700 font-medium">
                  Text instructions have been removed. Please watch the video above for safety guidance.
                </p>
              </div>
            </div>
          </div>
        </motion.div>
      </div>
    </div>
  );
};

export default ArticlePage;